module.exports = __webpack_public_path__ + "img/5.73b6f99d.jpg";